import Encoding from "encoding-japanese";
export const timeCurrentIso8601 = () => (new Date()).toISOString();

// ファイルをbase64にエンコードする
export const encodeFileToBase64 = (fileBlob, callback) => {
    const reader = new FileReader();
    reader.readAsDataURL(fileBlob);
    reader.onload = () => {
        const base64 = reader.result;
        const dataPart = base64.split(',')[1]; // 'data:image/png;base64,' の後の部分を取得
        callback(dataPart);
    };
    reader.onerror = (error) => {
        console.error('Error converting file to base64!', error);
    };
};

// Base64文字列をBlobデータにデコードする
export const decodeBase64ToBlob = (base64, mimeType) => {
    // Base64文字列をバイナリデータに変換する
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    // 文字列をバイト配列に変換
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    // Uint8Arrayを作成
    const byteArray = new Uint8Array(byteNumbers);

    // Blobデータを作成
    return new Blob([byteArray], { type: mimeType });
};

// 現在時間を%Y-%m-%dT%H:%M:%S形式で取得する
export const getTime = () => {
    const now = new Date();

    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
        timeZone: 'Asia/Tokyo'
    };

    const formattedDate = new Intl.DateTimeFormat('en-CA', options).format(now);

    // フォーマットを整える
    const [date, time] = formattedDate.split(', ');
    const formattedDateTime = date.replace(/\//g, '-') + ' ' + time;

    return formattedDateTime;
};

export const waitSecond = (seconds) => {
    return new Promise(resolve => setTimeout(resolve, (seconds * 1000)));  // 1000ミリ秒 = 1秒
}

export const ReverseKeyValue = (obj) => {
    const invertedObj = {};

    for (let key in obj) {
        const value = obj[key];
        
        // 重複するバリューがあった場合は無視
        if (!(value in invertedObj)) {
            invertedObj[value] = key;
        }
    }

    return invertedObj;
};


export const FormatDate = (isoString=null) =>  {
    let date = new Date();
    if (isoString != null)
    {
        date = new Date(isoString);
    }
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');  // 月は0から始まるので+1
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}年${month}月${day}日`;
}

export const FormatDateTime = (isoString=null) =>  {
    let date = new Date();
    if (isoString != null)
    {
        date = new Date(isoString);
    }
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');  // 月は0から始まるので+1
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}年${month}月${day}日 ${hours}時${minutes}分`;
}

export const HexToRgb =  (hex) => {
    // "#"を取り除く
    hex = hex.replace(/^#/, "");

    // 3桁の場合を6桁に展開
    if (hex.length === 3) {
        hex = hex.split("").map(char => char + char).join("");
    }

    // R, G, B値を取得
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return { r, g, b };
}

export const ConvertMarkdownToHTML = (markdown) => {
    // 1. 見出しを処理（# を <span class="header"> に変換）
    let html = markdown.replace(/^# (.+)$/gm, '<span class="text-size-h1">$1</span>');
    html = html.replace(/^## (.+)$/gm, '<span class="text-size-h2">$1</span>');
    html = html.replace(/^### (.+)$/gm, '<span class="text-size-h3">$1</span>');

    // 2. 強調を処理
    html = html.replace(/\*\*(.+?)\*\*/g, '<span class="bold">$1</span>'); // **太字**
    html = html.replace(/\*(.+?)\*/g, '<span class="italic">$1</span>');   // *斜体*

    // 3. 箇条書きを処理（- を <ul><li> に変換し、改行を無視）
    html = html.replace(/- (.+)$/gm, '・$1');

    // 4. リンクを処理（[text](url) を <a> に変換）
    html = html.replace(/^https:\/\/[^\s]+$/gm, '<a href="$&" target="_blank">$&</a>');

    // 5. 改行を処理（リスト外の改行のみ変換）
    html = html.replace(/\n(?!<\/?ul|<\/?li>)/g, '<br>');

    return html;
}


/**
 * SJIS/UTF-8混在のCSVをUTF-8に変換したFileとして返す
 * @param file アップロードされたCSVファイル
 * @returns UTF-8 に変換された File オブジェクト
 */
export const GetEncodedCSV = async (file) => {
    const arrayBuffer = await file.arrayBuffer();
    const bytes = new Uint8Array(arrayBuffer);

    // UTF-8に変換したバイト列（テキストではなく ArrayBuffer）
    const utf8Bytes = Encoding.convert(bytes, {
        to: "UTF8",
        from: Encoding.detect(bytes),
        type: "arraybuffer"
    });

    const utf8Blob = new Blob([utf8Bytes], { type: "text/csv;charset=utf-8" });

    const utf8File = new File([utf8Blob], file.name, {
        type: "text/csv",
        lastModified: Date.now(),
    });

    return utf8File;
};

export const DownloadCsvAsSJIS = async (url, filename = "download.csv") => {
    const response = await fetch(url);

    if (!response.ok) {
        throw new Error(`Failed to fetch CSV: ${response.status}`);
    }

    const utf8Text = await response.text();
    console.log(utf8Text);

    // UTF-8 ⇒ SJIS に変換（Excel向け）
    const sjisBytes = Encoding.convert(utf8Text, {
        to: 'SJIS',
        from: 'UNICODE',
        type: 'arraybuffer',
    });

    const blob = new Blob([sjisBytes], { type: "text/csv" });
    const blobUrl = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = filename;
    a.click();

    URL.revokeObjectURL(blobUrl);
};

export const DownloadCsvAsUtf8BOM = async (url, filename = "download.csv") => {
    const response = await fetch(url);

    if (!response.ok) {
        throw new Error(`Failed to fetch CSV: ${response.status}`);
    }

    const utf8Text = await response.text();
    console.log(utf8Text);  // 確認ログ

    // UTF-8 BOMを先頭に追加（Excel対策）
    const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
    const blob = new Blob([bom, utf8Text], { type: "text/csv;charset=utf-8" });

    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(blobUrl);
};